import React from "react";
// import UsersTable from "../components/Admin/usersTable";
// import MeetingsPage from "./admin/meetings.js";
import AdminLayout from "./admin/AdminLayout";

export default function AdminPage() {
  return (
    <AdminLayout>
      <h1>Admin Settings</h1>
      <p>Content will load into this panel.</p>
    </AdminLayout>
  );
}